export type RatingData = {
  rating: number;
  comment: string;
  date: string;
  source: "admin" | "client";
};

const STORAGE_KEY = "system_rating";

export const getRating = (): RatingData | null => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? (JSON.parse(data) as RatingData) : null;
  } catch {
    return null;
  }
};

export const saveRating = (data: Omit<RatingData, "date">): void => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...data, date: new Date().toISOString() })
  );
};

export const hasRated = (): boolean => !!getRating();
